const escapeCsvCell = (value) => {
  if (value === null || value === undefined) return '';
  const raw = String(value);
  // Spreadsheet applications interpret these prefixes as formulas. Queries
  // are merchant-controlled data, so keep them literal in downloaded files.
  const text = typeof value === 'string' && /^[=+\-@]/.test(raw) ? `'${raw}` : raw;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const buildAnalyticsCSV = (headCells, rows) => {
  const columns = headCells.filter(({ id }) => Boolean(id));
  return [
    columns.map(({ label }) => escapeCsvCell(label)).join(','),
    ...(Array.isArray(rows) ? rows : []).map((row) => columns
      .map(({ id, exportValue }) => escapeCsvCell(
        typeof exportValue === 'function' ? exportValue(row) : row[id],
      ))
      .join(',')),
  ].join('\r\n');
};

export const generateAndDownloadCSV = (headCells, rows) => {
  const blob = new Blob(['\ufeff', buildAnalyticsCSV(headCells, rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'data.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(url), 0);
};
